<template>
    <v-dialog
        :value="showDialog"
        persistent
        max-width="550"
    >        
      <v-card>
        <v-card-title class="text-h6 white--text meablue">Cancel App?</v-card-title>
        <v-card-text>
          <p class="text-subtitle-1 mt-2">Please confirm that you would like to cancel this application</p>
        </v-card-text>
        <v-card-actions>          
          <v-btn
            :disabled="canceling"
            color="green darken-1 white--text"
            @click="$emit('close-dialog')"
          >
            Continue App
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            :disabled="canceling"
            :loading="canceling"
            color="red darken-3 white--text"          
            @click="cancelApp"
          >
            Cancel App
          </v-btn>
        </v-card-actions>
      </v-card>
    <error-dialog :showDialog="showError" :errorObject="errorObject" :errorIsFatal="errorIsFatal" @close-dialog="showError=false"></error-dialog>
    </v-dialog>    
</template>

<script>
  import axios from 'axios';
  import commonMixins from '@/mixins/commonMixins';
  import ErrorDialog from './ErrorDialog.vue';
  

  export default {
    name: 'HelpDialog',
    components: {ErrorDialog},
    mixins: [commonMixins],
    data:()=>({
        showError:false,
        errorObject: {},
        errorIsFatal:false,
        canceling:false
    }),
    props: {
        showDialog: Boolean
    },
    methods:{
        async cancelApp(){
            this.canceling = true;
            const payload = {doCmd: 'cancel_app', app_id: window.sessionStorage.getItem('appID')};
            const cancel_res = await axios.post(`${this.$baseURL}/common/application/`, JSON.stringify(payload), {
                headers: {'Content-Type':'application/json'}
            });
            
            if(cancel_res.data.error > 0){
              this.canceling = false;
              delete cancel_res.data.result;
              this.showError = true;
              this.errorObject = cancel_res.data;
              return;
            }

            window.sessionStorage.clear();
            location.reload();
        }   
    },    
  }
</script>
<style scoped>
.meablue{
    background-color:var(--meablue);
}
</style>